import { render, staticRenderFns } from "./UserProfilePage.vue?vue&type=template&id=950214da&"
import script from "./UserProfilePage.vue?vue&type=script&lang=ts&"
export * from "./UserProfilePage.vue?vue&type=script&lang=ts&"
import style0 from "./UserProfilePage.vue?vue&type=style&index=0&id=950214da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports